import React from 'react'

export default function NotFound() {
    return (
        <main>
            <div className='container-fluid'>
                <div className='card'>
                    <div className='card-body text-center py-5'>
                        <h2 style={{fontSize:100}}>404</h2>
                        <h3 className='h1'>Page not found!</h3>
                    </div>
                </div>
            </div>
        </main>
    )
}
